import { portalBase2v } from '@App/dicts/pathes'

export class SystemSettings {
    distributionDate = portalBase2v('system-settings/distribution-date')
}
